import { worshipTimes } from "../../data/worship-times";
import { createSlide } from "../../slidesOps/createSlide";
import { sortByProp } from "../../../../utilities/sortByProp";
import { filterMeetingSchedule } from "./filterMeetingSchedule";
import { getListOfScheduledDays } from "./getListOfScheduledDays";
import { gospelMeetingBG } from "./gospelMeetingBG";
import { leadInLogoGospelMeeting } from "./leadInLogoGospelMeeting";
import { slideGospelMeetingTEMP } from "./slideGospelMeetingTemp";
import { getScheduleToday } from "./getToday";
import { buildSlides } from "../../slidesOps/buildSlides";
import { autoAddRemoveBy } from "../../../cpcoc/autoAddRemoveBy";
import { refreshCurrentDate } from "../../../cpcoc/currentDate";
import { querySelectorURL } from "../../../cpcoc/querySelectorURL";
// TODO: Need to clean this up
// TODO: Consider scaling...
export function slideGospelMeeting() {
    var _a, _b;
    // // Theme Focus Weekend
    if (querySelectorURL("group") === "foyer" && autoAddRemoveBy(false, new Date("03/30/2025 7:00 PM"))) {
        createSlide({
            autoslide: 30000,
            background: {
                image: "https://www.cedarparkchurchofchrist.org/media/uploads/src/board/THEME%20FOCUS%20PPT%20slide%2016-9.png",
            },
        }, `Theme Focus Weekend 16-9`);
    }
    if (querySelectorURL("group") === "auditorium" && autoAddRemoveBy(false, new Date("03/30/2025 7:00 PM"))) {
        createSlide({
            autoslide: 30000,
            background: {
                image: "https://www.cedarparkchurchofchrist.org/media/uploads/src/board/THEME%20FOCUS%20PPT%20slide%204-3.png",
            },
        }, `Theme Focus Weekend 4-3`);
    }
    const schedule = worshipTimes
        .filter(filterMeetingSchedule)
        .sort(sortByProp("date"));
    if (!schedule.length) {
        return false;
    }
    const firstMeetingDate = (_a = schedule[0]) === null || _a === void 0 ? void 0 : _a.date;
    const lastMeetingDate = (_b = schedule[schedule.length - 1]) === null || _b === void 0 ? void 0 : _b.date;
    const showHidePadding = 3;
    const hideOn = new Date(`${lastMeetingDate.toDateString()} ${lastMeetingDate.getHours() + showHidePadding}:${lastMeetingDate.getMinutes()}`);
    const showOn = new Date(`${firstMeetingDate.toDateString()} ${firstMeetingDate.getHours() - showHidePadding}:${firstMeetingDate.getMinutes()}`);
    // window.autoAddRemoveBy(false, new Date('04/06/2024 15:00:00'), slideGospelMeetingTEMP);
    console.log(schedule);
    if (!autoAddRemoveBy(false, hideOn)) {
        // do nothing if the gospel meeting doesn't exist, or has completely expired.
        return false;
    }
    else if (!autoAddRemoveBy(showOn, hideOn)) {
        // do this only if the gospel meeting is not YET in range
        slideGospelMeetingTEMP(); // schedule);
        return false;
    }
    const scheduleToday = getScheduleToday(schedule);
    if (scheduleToday) {
        buildSlides([scheduleToday === null || scheduleToday === void 0 ? void 0 : scheduleToday.slideIndex]);
        return false;
    }
    const scheduledDays = getListOfScheduledDays(schedule);
    const now = refreshCurrentDate();
    const body = document.querySelector("body");
    let slidesHTML = "";
    const [datesHTML, servicesHTML] = slideScheduleByDay();
    body.classList.add("gospel-meeting-body");
    body.prepend(gospelMeetingBG());
    slidesHTML += `
        <style>
            /* GOSPEL MEETING STYLES */
            .gospel-meeting-body #countdown {
                background: transparent;
                display: flex;
                justify-content: center;
                align-items: center;
                margin: -8px 0;
            }

            .gospel-meeting-body #countdown,
            .gospel-meeting-body #countdown .countdown__value,
            .gospel-meeting-body #countdown .lead-presenter,
            .gospel-meeting-body #countdown h1 {
                color: #fff;
            }

            .gospel-meeting-body #countdown .date {
                font-size: .75em;
            }

            .gospel-meeting-body #countdown .countdown__msg {
                font-size: 4.29vh;
                margin-top: 20vh;
            }

            @media (min-width: 1080px) {
                .gospel-meeting-body #countdown .countdown__msg {
                    font-size: 3.82vh;
                }
            }

            .gospel-meeting-body #countdown .countdown__value {
                font-weight: 500;
                position: static;
                font-size: 20vh;
            }

            .gospel-meeting-body #countdown .countdown__container > .countdown__value {
                display: none;
            }

            .gospel-meeting-body #countdown .countdown__container {
                text-align: center;
                position: static;
                margin-bottom: 0;
                transform: translateY(-100%);
                transition: transform .75s ease-in-out;
            }

            .countdown--active.gospel-meeting-body #countdown .countdown__container {
                transform: translateY(0);
            }

            .gospel-meeting-body .gospel-meeting-bg::after {
                transform: scaleY(1);
                transform-origin: bottom;
                transition: transform .75s ease-in-out;
            }

            .countdown--active.gospel-meeting-body .gospel-meeting-bg::after {
                transform: scaleY(1.75);
                transform-origin: bottom;
            }







            @import url('https://fonts.googleapis.com/css2?family=Archivo:ital,wght@0,100..900;1,100..900&display=swap');

            .gospel-meeting-content {
                text-align: center;
                font-size: 2em;
            }

            .gospel-meeting-content .content {
                position: relative;
                z-index: 4;
                display: inline-block;
                text-align: left;
                margin-left: 2em;

                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
            }

            .gospel-meeting-content,
            .gospel-meeting-content h1,
            .gospel-meeting-content p {
                font-family: "Archivo", sans-serif;
                font-optical-sizing: auto;
                font-style: normal;
                font-variation-settings: "wdth" 100;
                font-weight: 400;
                font-style: italic;
            }

            .gospel-meeting-content h1 {
                margin: 0;
                padding: 0;
                text-transform: uppercase;
                line-height: .9;
                font-size: 1.35em;
                margin-bottom: -.1em;
            }

            .gospel-meeting-content h1 em {
                font-style: normal;
                display: block;
                font-weight: 900;
                margin-left: -0.05em;
                font-size: 1.75em;
                padding: 0;
                transform: scale(1, .75);
                transform-origin: top left;
            }

            #gospel-meeting .gospel-meeting-content h1 .fragment {
                display: block;
                opacity: 0;
                filter: blur(20px);
                transform: scale(2);
                transform-origin: top left;
                transition: opacity .5s ease-in-out, filter .5s ease-in-out, transform .5s ease-in-out;
            }

            section#gospel-meeting.present .gospel-meeting-content h1 .visible {
                opacity: 1;
                filter: none;
                transform: scale(1);
            }

            section#gospel-meeting.present .gospel-meeting-content h1 em.visible {
                transform: scale(1, .75);
            }

            .gospel-meeting-content .date {
                position: relative;
                font-size: .85em;
                font-style: initial;
                color: #f3dcca;
                text-align: left;

                padding: .25em 0;
                margin: 0;
                line-height: 1;

                font-weight: 200;
            }

            .gospel-meeting-content .date > * {
                width: 100%;
            }

            .gospel-meeting-content .date::before {
                content: '';
                position: absolute;
                left: -.75em;
                top: 0;
                height: 100%;
                width: 150vw;
                background: #215179;
                border-radius: .75em;
                z-index: -1;
            }

            #gospel-meeting .gospel-meeting-content .date.fragment::before {
                transform: translateX(100%);
                transition: transform 1s ease-in-out;
            }

            section#gospel-meeting.present .gospel-meeting-content .date.visible::before {
                transform: translateX(0);
            }

            #gospel-meeting .gospel-meeting-content .date .fragment {
                display: block;
                transform: translateX(50%);
                opacity: 0;
                filter: blur(20px);
                transition: transform .5s ease-in-out, opacity .5s ease-in-out, filter .5s ease-in-out;
            }

            section#gospel-meeting.present .gospel-meeting-content .date .visible.current-fragment {
                transform: translateX(0);
                opacity: 1;
                filter: none;
            }

            .gospel-meeting-content .lead-presenter {
                font-size: .6em;
                margin-top: .3em;
                margin-bottom: 0;
                font-weight: 200;
            }

            .gospel-meeting-content .lead-presenter > * {
                width: 100%;
            }

            #gospel-meeting .gospel-meeting-content .lead-presenter .fragment {
                display: block;
                filter: blur(20px);
                opacity: 0;
                transform: translateX(50%);
                transition: transform .5s ease-in-out, opacity .5s ease-in-out, filter .5s ease-in-out;
            }

            section#gospel-meeting.present .gospel-meeting-content .lead-presenter .visible.current-fragment {
                transform: translateX(0);
                filter: none;
                opacity: 1;
            }
            
            .gospel-meeting-content .lead-presenter > * {
                margin: 0;
            }

            .gospel-meeting-content .lead-presenter .service {
                margin-bottom: .1em;
                position: relative;
            }

            .gospel-meeting-content .lead-presenter .service.past > * {
                opacity: .25;
                text-decoration: line-through;
            }

            .gospel-meeting-content .lead-presenter .time {
                margin-bottom: 0;
                font-size: .8em;
                font-weight: 200;
                margin: 0;
            }

            .gospel-meeting-content .lead-presenter .title {
                margin: 0;
                font-weight: 700;
            }

            .gospel-meeting-content .lead-presenter .service.next::before {
                content: '';
                position: absolute;
                left: -30px;
                top: 0;
                width: 10px;
                height: 100%;
                background: #fff;
            }

            .gospel-meeting-content .content .images {
                margin-top: .2em;
                float: right;
                position: relative;
                z-index: 2;
            }

            .gospel-meeting-content .content img {
                width: 3.5em;
                height: auto;
                aspect-ratio: 1/1;
                border-radius: 50%;
                border: .15em solid #fff;
                background: #fff;
            }

            #gospel-meeting .gospel-meeting-content .content img.fragment {
                transform: scale(0);
                transition: transform .25s ease-in-out;
                transform-origin: center;
            }

            section#gospel-meeting.present .gospel-meeting-content .content img.visible {
                transform: scale(1);
            }




            .gospel-meeting-body .informer {
                max-width: 79%;
                margin-left: 21%;
            }

            .gospel-meeting-body .informer .informer__headline {
                max-width: 650px;
            }

            .gospel-meeting-body .worship-pointer .title-group {
                left: 25%
            }






            .gospel-meeting-body .reveal {
                opacity: 1;
                transition: opacity .2s ease-in-out;
            }

            .gospel-meeting-body.countdown--active .reveal {
                opacity: 0;
            }

            .gospel-meeting-body .slide-background.video-bg {
                display: none;
                opacity: 0;
                visibility: hidden;
            }
        </style>

        ${leadInLogoGospelMeeting(`
                <div class="fragment" data-fragment-index="3" data-autoslide="25000">April 7&ndash;10</div>
                ${datesHTML}
            `, `
                <div class="fragment" data-fragment-index="3" data-autoslide="250" style="transition-delay: .1s">Speaker Edwin Crozier</div>
                ${servicesHTML}
            `, '<img class="fragment" data-fragment-index="2" alt="Edwin Crozier" src="https://www.cedarparkchurchofchrist.org/media/uploads/public/gospel-meeting/2024-learning-prayer/edwin_crozier.jpg" />')}
    `;
    function slideScheduleByDay() {
        let dateHTML = ``;
        let titleHTML = ``;
        const relevantDays = scheduledDays.filter((d, index) => index >= scheduledDays.indexOf(now.getDay()));
        let animationIndex = 3;
        let nextService = false;
        for (let i = 0, l = relevantDays.length; i < l; i++) {
            animationIndex++;
            const day = relevantDays[i];
            let transitionDelay = 0.25;
            const servicesForDay = schedule.filter((item) => day === item.date.getDay());
            dateHTML += `
                <div class="fragment" data-fragment-index="${animationIndex}" data-autoslide="15000">
                    ${servicesForDay[0].day}
                </div>
            `;
            titleHTML += `<div class="day-group">`;
            for (let i = 0, l = servicesForDay.length; i < l; i++) {
                const service = servicesForDay[i];
                let serviceStatus = "";
                transitionDelay += 0.2;
                if (service.date < now) {
                    serviceStatus = " past";
                }
                else if (!nextService) {
                    serviceStatus = " next";
                    nextService = true;
                }
                titleHTML += `<div class="fragment service${serviceStatus}" data-fragment-index="${animationIndex}" style="transition-delay: ${transitionDelay}s">`;
                titleHTML += `
                    <p class="time">${service.time} ${service.period}</p>
                    <p class="title">${service.title}</p>
                `;
                titleHTML += `</div>`;
            }
            titleHTML += `</div>`;
        }
        return [dateHTML, titleHTML];
    }
    createSlide({
        autoslide: 250,
        // center: true,
        wrap: "false",
        html: slidesHTML,
        background: { color: null },
    }, "gospel-meeting");
}
